import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i7.6
import React from 'react';
import IconWrap from '../../IconWrap';
const BlockAlign = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19 17a1 1 0 010 2H5a1 1 0 010-2zm0-6a1 1 0 010 2H5a1 1 0 010-2zM4 6a1 1 0 001 1h14a1 1 0 000-2H5a1 1 0 00-1 1z",
        transform: "matrix(-1 0 0 1 24 0)"
    })));
};
BlockAlign.displayName = 'BlockAlign';
export default BlockAlign;
